import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-entity-selector',
  template: `
    <ng-select
      [items]="filteredEntities$ | async"
      bindLabel="name"
      bindValue="id"
      [searchable]="true"
      [groupBy]="'category'"
      [virtualScroll]="true"
      [typeahead]="searchTerm$"
      placeholder="Selecciona una entidad">
    </ng-select>
  `,
  styles: [`
    ng-select {
      width: 100%;
    }
  `]
})
export class EntitySelectorComponent implements OnInit {
  entities: any[] = [];
  filteredEntities$!: Observable<any[]>;
  searchTerm$ = new Subject<string>();

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.http.get<any[]>('assets/data/3000clients.json').subscribe(data => {
      this.entities = data.map(entity => ({
        id: entity.id,
        name: `${entity.name} (${entity.internalCode})`,
        category: this.getCategory(entity.entityType.name)
      }));
      this.filteredEntities$ = this.searchTerm$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(term => this.filterEntities(term))
      );
    });
  }

  getCategory(entityType: string): string {
    if (entityType === 'distributor') return 'Distribuidores';
    if (entityType === 'headoffice') return 'Head Offices';
    if (entityType === 'shop') return 'Shops';
    return 'Otros';
  }

  filterEntities(term: string): Observable<any[]> {
    return new Observable(observer => {
      const filtered = this.entities.filter(entity => entity.name.toLowerCase().includes(term.toLowerCase()));
      observer.next(filtered);
      observer.complete();
    });
  }
}
